export const STORAGE_KEY_SEARCH_HISTORY = 'cs_search_history_v1';
export const STORAGE_ARRAY_DELIMITER = ',';
export const STORAGE_LIMIT = 5;

export const getHistoryListFromLocalStorage = () => {
	const historyListString = localStorage.getItem(STORAGE_KEY_SEARCH_HISTORY) ?? '';

	return historyListString ? historyListString.split(STORAGE_ARRAY_DELIMITER) : [];
};

export const addHistoryItemToLocalStorage = (input: string) => {
	const historyList = getHistoryListFromLocalStorage();

	if (!input || historyList.includes(input)) return;

	if (historyList.length === STORAGE_LIMIT) {
		historyList.pop();
	}

	const newHistoryList = [input, ...historyList];

	localStorage.setItem(STORAGE_KEY_SEARCH_HISTORY, newHistoryList.join(STORAGE_ARRAY_DELIMITER));
};

export const removeHistoryItemsFromLocalStorage = () => {
	localStorage.removeItem(STORAGE_KEY_SEARCH_HISTORY);
};
